import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class SignatureEventBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new SignatureEventBox({
            uuid,
            graph,
            name: "SignatureEventBox",
            pointerRules: {
                accepts: [Pointers.Selection],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "SignatureEventBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitSignatureEventBox, this);
    }
    get tags() {
        return SignatureEventBox.Tags;
    }
    get events() {
        return this.getField(1);
    }
    get index() {
        return this.getField(9);
    }
    get relativePosition() {
        return this.getField(10);
    }
    get nominator() {
        return this.getField(21);
    }
    get denominator() {
        return this.getField(22);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "events",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.SignatureAutomation, true),
            9: Int32Field.create({
                parent: this,
                fieldKey: 9,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", "", 0),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "relativePosition",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "bars", 1),
            21: Int32Field.create({
                parent: this,
                fieldKey: 21,
                fieldName: "nominator",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "", 4),
            22: Int32Field.create({
                parent: this,
                fieldKey: 22,
                fieldName: "denominator",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "", 4),
        };
    }
}
